<template>
  <div>
    <div class="modal-title">{{ $t('new_place_title') }}</div>
    <div class="modal-content">
      <p class="mt-4 text-label text-xs">{{ $t('destination_label') }}</p>
      <select v-model="placeId" class="modal-select">
        <option v-for="place in favorites" v-bind:key="place.id" v-bind:value="place.id">
          {{ place.name }} 
        </option>
      </select>
      <p class="mt-4 text-label text-xs">{{ $t('residence_time_label') }}</p>
      <time-select v-model="time" />
    </div>
    <div class="modal-button">
      <a class="button-primary block" @click="handleClick">{{ $t('add') }}</a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TimeSelect from "./TimeSelect"

export default {
  components: {
    TimeSelect
  },
  props: {
    target: {
      type: Object,
      required: true
    },
    callback: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      placeId: undefined,
      time: 60,
      places: [],
      timeOptions: []
    }
  },
  created: function () {
    if (this.favorites.length > 0) {
      this.placeId = this.favorites[0].id
    }
  },
  computed: {
    ...mapGetters({
      favorites: 'favorites/getFavoritedPlaces'
    })
  },
  methods: {
    handleClick: function () {
      const place = this.$store.getters['places/getPlace'](this.placeId)
      this.callback(this.target.route, this.time, place)
    }
  }
}
</script>
